const colors = {
  black: '#000000',
  white: '#FFFFFF',
  gray: '#808080',
};

export const position = {
  glass: '#BAE7FF',
  areaSelectorStroke: '#1890FF',
  frameStroke: colors.black,
  frameFill: colors.white,
  sashTypeIndicatorStroke: colors.black,
  handleFill: colors.white,
  handleStroke: colors.black,
  mullion: colors.white,
  transom: colors.white,
  sashbar: colors.gray,
};

export const dimensionLines = {
  grid: 'transparent',
  frame: '#070761',
};
